module.exports = require('./helpers/bundle-url').getBundleURL('aL8Pt') + "logo-dark.ba5147f0.svg";